import { render, staticRenderFns } from "./PopupScopeSchool.vue?vue&type=template&id=2f41f257&scoped=true&lang=pug&"
import script from "./PopupScopeSchool.vue?vue&type=script&lang=ts&"
export * from "./PopupScopeSchool.vue?vue&type=script&lang=ts&"
import style0 from "./PopupScopeSchool.vue?vue&type=style&index=0&id=2f41f257&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41f257",
  null
  
)

export default component.exports